export const superAdmin = ['super-admins', 'administrators']
export const adminGroups = [...superAdmin, 'summit-front-end-administrators'];
export const authorizedGroups = [...adminGroups];
